<template>
  <div v-if="data">
    <div class="container report-ready-page">
      <div>
        <img
          class="gyranian-image"
          src="../assets/gyranian-strengths-mapping.png"
          alt="Gyranian rating his strengths"
        />
      </div>
      <div>
        <h2>Complete Review</h2>
        <p style="margin-bottom: 25px">
          {{ data.name }} has invited you to complete a review of {{ data.firstName }}'s character
          strengths. This will help {{ data.firstName }} build an accurate self-view.
        </p>

        <a
          @click="acceptInvite"
          @keydown.enter="acceptInvite"
          role="button"
          tabindex="0"
          class="btn btn-primary btn-lg center-flex"
          data-test="get-started-button"
        >
          Get Started
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from "axios";
import useAxios from "../composables/api";
import { InviteCodeSubjectApiModel, QuestionnaireApiModel } from "../api-models";

const props = defineProps<{ code: string }>();

const { data } = useAxios<InviteCodeSubjectApiModel>(`/api/invitecode/subject/${props.code}`);

const redirectToReview = (model: QuestionnaireApiModel) => {
  if (model.customStrengthMappingId?.length > 0) {
    window.location.href = `/review/precheck/${model.id}`;
  } else {
    window.location.href = `/review/mappingstrengths/${model.id}`;
  }
};

const acceptInvite = async () => {
  const response = await axios.post<QuestionnaireApiModel>("/invite/accepted/", {
    code: props.code,
  });

  if (response.status === 200) {
    redirectToReview(response.data);
  }
};
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";

.report-ready-page {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;

  & > div {
    flex: 1;
    padding: 1rem;
    width: 50%;
  }
}

.gyranian-image {
  width: 100%;
}

.open-access {
  margin: 10px 0;
}

@media (max-width: @screen-xs-max) {
  .report-ready-page {
    flex-direction: column-reverse;

    & > div {
      width: 100%;
    }
  }

  .gyranian-image {
    display: none;
  }
}
</style>
